<template>
	<div class="mediaVideo">
		<you-tube-playlist 
			:videos="links" 
			aspect-ratio="640:360"
			ref="vidContainer" 
			class="videoContainer">
		</you-tube-playlist>


	</div>	
</template>

<script>
import YouTubePlaylist from '../playlist/YouTubePlaylist';
import find from 'lodash/find';

export default{
	name: "Videos",
	components:{ YouTubePlaylist },
	computed:{
	},
	created(){
		this.getVideos();
	},
	data(){
		return {
			tag: 19,
			links: []
		}
	},
	methods:{
		getVideos: function(){
			let posts = this.videos;
			let videoPost = find(posts, (v) => {
				return v.tags.includes(this.tag);
			});

			let string = videoPost.content.rendered.replace('\n','').replace('<p>','').replace('</p>','');
			this.links = string.split('<br>');
		}
	},
	mounted(){
		// this.device();		
	},
	props: [ 'videos' ],
	watch: {
		videos: function(){
			this.getVideos();
		}
	}
}
</script>

<style scoped lang="scss">
	@import '~@/assets/scss/_variables.scss';

	.mediaVideo{
		width: 90%;
		max-height: 100%;
		overflow: hidden;
		margin: auto;

		.videoContainer{
			overflow: hidden;
			display: grid;
			grid-template-columns: 80% 20%;
			grid-template-rows: 90% 10%;
			margin: auto;
		}

		// .vidNav{
		// 	color: $nearWhite;
		// 	font-family: 'Montserrat', sans-serif;
		// 	text-align: center;
		// 	margin-top: 10px;
		// 	display: grid;
		// 	grid-template-columns: 70% 30%;
		// }
	}

	@media screen and (max-width: $regularLaptopWidth){
		.mediaVideo{
			transform: translateY(10%);
		}
	}

	@media screen and (max-width: $tabletWidth){
		.mediaVideo{
			.videoContainer{
				grid-template-columns: none;
				grid-template-rows: 65% 30% 5%;
			}
		}
	}

	@media screen and (max-width: $largeMobile){
		.mediaVideo{
			transform: translateY(33%);
		}		
	}
</style>